import { render, staticRenderFns } from "./AmountCents.vue?vue&type=template&id=064c99d0&scoped=true&"
import script from "./AmountCents.vue?vue&type=script&lang=js&"
export * from "./AmountCents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c99d0",
  null
  
)

export default component.exports